export enum AuthMethod {
    Password = 1,
    PIN,
    OTP
}